import React from 'react';


export const VisitasComponent = React.lazy(() => import('./Visitas.jsx'));